module.exports = __webpack_public_path__ + "img/eg.4f1ae3d5.svg";